import styles from "./styles.module.scss";
import cn from "classnames";
import { useState } from "react";

const defaultSectorDetails = {
  Electrical: {
    description:
      "<p>We provide expert recruitment for all aspects of electrical systems, ensuring safety, compliance, and efficiency from power distribution to back-up power solutions.</p>",
    tags: [
      { specialism: "Power Distribution" },
      { specialism: "Redundancy & Reliability" },
      { specialism: "Back Up Power" },
      { specialism: "Energy Efficiency" },
      { specialism: "Safety & Compliance" },
    ],
  },
  "Health & Safety": {
    description:
      "<p>Our specialists connect you with top-tier talent in Health & Safety, focusing on risk management, regulatory compliance, and fostering a secure work environment.</p>",
    tags: [
      { specialism: "Risk Assessment" },
      { specialism: "Safety Audits" },
      { specialism: "Regulatory Compliance" },
      { specialism: "Occupational Health" },
      { specialism: "Training & Development" },
    ],
  },
  Comissioning: {
    description:
      "<p>We specialize in sourcing commissioning experts who ensure that all parts of a project are designed, installed, tested, and maintained correctly.</p>",
    tags: [
      { specialism: "System Integration" },
      { specialism: "Quality Assurance" },
      { specialism: "Performance Testing" },
      { specialism: "Handover & Documentation" },
      { specialism: "Project Validation" },
    ],
  },
  "CSA Practice": {
    description:
      "<p>Connecting you with leading professionals in Civil, Structural, and Architectural (CSA) practices to build the foundation of your mission-critical projects.</p>",
    tags: [
      { specialism: "Structural Engineering" },
      { specialism: "Civil Design" },
      { specialism: "Architectural Planning" },
      { specialism: "Site Management" },
      { specialism: "Building Regulations" },
    ],
  },
  Mechanical: {
    description:
      "<p>From HVAC to industrial machinery, we recruit skilled mechanical engineers and technicians to drive innovation and maintain operational excellence.</p>",
    tags: [
      { specialism: "HVAC Systems" },
      { specialism: "Piping & Instrumentation" },
      { specialism: "Fluid Dynamics" },
      { specialism: "Energy Systems" },
      { specialism: "Robotics & Automation" },
    ],
  },
};

export const MissionCriticalSectors = ({ title, description, sectors, backgroundColor = "gradient1" }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const activeSector = sectors?.[activeIndex];

  const sectorDescription = activeSector?.description || defaultSectorDetails[activeSector?.title]?.description;

  const sectorTags =
    activeSector?.tags && activeSector.tags.length > 0
      ? activeSector.tags
      : defaultSectorDetails[activeSector?.title]?.tags;

  return (
    <section className={cn(styles.MissionCriticalSectors, styles[backgroundColor])}>
      <div className={styles.glow} />
      <h2 data-sourceflow-prop="title">{title}</h2>
      <div
        className={styles.description}
        data-sourceflow-prop="description"
        dangerouslySetInnerHTML={{ __html: description }}
      />

      <div className={styles.hero}>
        <div className={styles.heroImage} style={{ backgroundImage: `url(${activeSector?.image?.url})` }} />
        <div className={styles.heroContent}>
          <h3>{activeSector?.title}</h3>

          {sectorDescription && <div dangerouslySetInnerHTML={{ __html: sectorDescription }} />}

          <h4>Key Specialisms</h4>
          <div className={styles.tags}>
            {sectorTags?.map((tag) => (
              <span key={tag.specialism}>{tag.specialism}</span>
            ))}
          </div>
        </div>
      </div>

      <div className={styles.sectorGrid}>
        {sectors.map(({ title, image }, i) => (
          <div
            key={i}
            className={cn(styles.sectorCard, { [styles.expanded]: i === activeIndex })}
            style={{ backgroundImage: `url(${image?.url})` }}
            onClick={() => setActiveIndex(i)}
          >
            <div className={styles.cardContent}>
              <span>{title}</span>
              <div className={styles.icon}>
                {i === activeIndex ? (
                  <svg width="21" height="3" viewBox="0 0 21 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M1.87129 0.75C1.27963 0.75 0.799805 1.22956 0.799805 1.82149C0.799805 2.41315 1.27961 2.89297 1.87129 2.89297H19.7283C20.32 2.89297 20.7998 2.41317 20.7998 1.82149C20.7998 1.22981 20.32 0.75 19.7283 0.75H1.87129Z"
                      fill="white"
                    />
                  </svg>
                ) : (
                  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M10.5996 0C10.0025 0 9.51853 0.484027 9.51853 1.08108V8.91895H1.68069C1.08364 8.91895 0.599609 9.40295 0.599609 10C0.599609 10.5971 1.08364 11.0811 1.68069 11.0811H9.51853V18.9189C9.51853 19.516 10.0025 20 10.5996 20C11.1967 20 11.6807 19.516 11.6807 18.9189V11.0811H19.5185C20.1156 11.0811 20.5996 10.5971 20.5996 10C20.5996 9.40295 20.1156 8.91895 19.5185 8.91895H11.6807V1.08108C11.6807 0.484027 11.1967 0 10.5996 0Z"
                      fill="white"
                    />
                  </svg>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MissionCriticalSectors;
